import angular from 'angular';
import tunnelComponent from './tunnel.component';
import TunnelService from './tunnel.service';
import tunnelConfig from './tunnel.config';
import ModalAddressController from './modal-address/modal-address.controller';
import AddressService from '../address/address.service';

let tunnelModule = angular.module('app.tunnel', [])
    .controller('ModalAddressController', ModalAddressController)
    .component('tunnel', tunnelComponent)
    .service('TunnelService', TunnelService)
    .service('AddressService', AddressService)
    .config(tunnelConfig);

export default tunnelModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/tunnel/tunnel.js
 **/